// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* direction */
  direction: rtl;
  /* || fonts */
  font-size: 0.625rem;
  --text-xs: 1.2rem;
  --text-sm: 1.4rem;
  --text-base: 1.6rem;
  --text-lg: 1.8rem;
  --text-xl: 2rem;
  --text-2xl: 2.4rem;
  --text-3xl: 3rem;
  --text-4xl: 3.6rem;
  /* || colors */
  --primary-color: #1d4eaf;
  --primary-color-20-opacity: #1d4eaf33;
  --primary-color-forty-opacity: #1d4eaf66;
  --warning-color: #f07427;
  --gray: #cecece;
  --gray-extra-light: #f6f6f6;
  --gray-semi-light: #d9d9d9;
  --gray-light: #ececec;
  --gray-dark: #677181;
  --gray-semi-dark: #aeaeae4d;
  --gray-extra-dark: #737373;
  --disabled: #c7c7c7;
  --white-light: #fbfbfb;
  --white-semi-light: #eaecf0;
  --white-semi-dark: #eee;
  --white-dark: #ffffff4d;
  --gold-light: #ffffc8;
  --gold-dark: #f9db46;
  --blue-extra-dark: #122a54;
  --sky-dark: #cbd9f65c;
  --sky: #cbd9f6;
  --sky-36-opacity: #cbd9f65c;
  --sky-dark: #a5b6d7;
  --black-extra-light: #333;
  --black-light: #212529;
  --black-dark: #1e1e1e;
  --black-ten-opacity: #0000001a;
  --black-eighty-opacity: #000000cc;
  --black-7-opacity: #00000012;
  --black-15-opacity: #00000026;
  --black-22-opacity: #00000038;
  --green-dark: #398118;
  --danger: #ad1f1f;
  --priced-orders-notify: #f44336;
  --red-extra-light: #ad1f1f1c;
  --primary-color-zero-opacity: #12295500;
  --wallet-banner: linear-gradient(270.55deg, #1d4eaf -20.22%, #ffffff 605.93%);
  --wallet-deduction: linear-gradient(
    270.55deg,
    rgba(173, 31, 31, 0.09) -20.22%,
    #ffffff 605.93%
  );
  --wallet-topup: linear-gradient(
    270.55deg,
    rgba(57, 129, 24, 0.17) -20.22%,
    #ffffff 605.93%
  );
  --discount: #21a600;
  --weekly-bonus-gradient: linear-gradient(
    270.55deg,
    #cbd9f6 -20.22%,
    #ffffff 605.93%
  );
  --promotion-gradient: linear-gradient(
    270.55deg,
    #cbd9f6 -20.22%,
    #cddbf6 8.73%,
    #ffffff 605.93%
  );
  /* || x-index */
  --z-modal: 999;
  --z-mechanic-menu: 888;
  --z-filter-menu: 777;
  --z-magnifier: 666;
}
`, "",{"version":3,"sources":["webpack://./src/style/variables.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,qCAAqC;EACrC,wCAAwC;EACxC,wBAAwB;EACxB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,uCAAuC;EACvC,6EAA6E;EAC7E;;;;GAIC;EACD;;;;GAIC;EACD,mBAAmB;EACnB;;;;GAIC;EACD;;;;;GAKC;EACD,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":[":root {\n  /* direction */\n  direction: rtl;\n  /* || fonts */\n  font-size: 0.625rem;\n  --text-xs: 1.2rem;\n  --text-sm: 1.4rem;\n  --text-base: 1.6rem;\n  --text-lg: 1.8rem;\n  --text-xl: 2rem;\n  --text-2xl: 2.4rem;\n  --text-3xl: 3rem;\n  --text-4xl: 3.6rem;\n  /* || colors */\n  --primary-color: #1d4eaf;\n  --primary-color-20-opacity: #1d4eaf33;\n  --primary-color-forty-opacity: #1d4eaf66;\n  --warning-color: #f07427;\n  --gray: #cecece;\n  --gray-extra-light: #f6f6f6;\n  --gray-semi-light: #d9d9d9;\n  --gray-light: #ececec;\n  --gray-dark: #677181;\n  --gray-semi-dark: #aeaeae4d;\n  --gray-extra-dark: #737373;\n  --disabled: #c7c7c7;\n  --white-light: #fbfbfb;\n  --white-semi-light: #eaecf0;\n  --white-semi-dark: #eee;\n  --white-dark: #ffffff4d;\n  --gold-light: #ffffc8;\n  --gold-dark: #f9db46;\n  --blue-extra-dark: #122a54;\n  --sky-dark: #cbd9f65c;\n  --sky: #cbd9f6;\n  --sky-36-opacity: #cbd9f65c;\n  --sky-dark: #a5b6d7;\n  --black-extra-light: #333;\n  --black-light: #212529;\n  --black-dark: #1e1e1e;\n  --black-ten-opacity: #0000001a;\n  --black-eighty-opacity: #000000cc;\n  --black-7-opacity: #00000012;\n  --black-15-opacity: #00000026;\n  --black-22-opacity: #00000038;\n  --green-dark: #398118;\n  --danger: #ad1f1f;\n  --priced-orders-notify: #f44336;\n  --red-extra-light: #ad1f1f1c;\n  --primary-color-zero-opacity: #12295500;\n  --wallet-banner: linear-gradient(270.55deg, #1d4eaf -20.22%, #ffffff 605.93%);\n  --wallet-deduction: linear-gradient(\n    270.55deg,\n    rgba(173, 31, 31, 0.09) -20.22%,\n    #ffffff 605.93%\n  );\n  --wallet-topup: linear-gradient(\n    270.55deg,\n    rgba(57, 129, 24, 0.17) -20.22%,\n    #ffffff 605.93%\n  );\n  --discount: #21a600;\n  --weekly-bonus-gradient: linear-gradient(\n    270.55deg,\n    #cbd9f6 -20.22%,\n    #ffffff 605.93%\n  );\n  --promotion-gradient: linear-gradient(\n    270.55deg,\n    #cbd9f6 -20.22%,\n    #cddbf6 8.73%,\n    #ffffff 605.93%\n  );\n  /* || x-index */\n  --z-modal: 999;\n  --z-mechanic-menu: 888;\n  --z-filter-menu: 777;\n  --z-magnifier: 666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
